export { default } from './carousel';